export default __webpack_public_path__ + "static/media/NonFerrousImg.bc230326.jpg";